import type { WithClassNameProp, WithDataTestid } from '@vlabs/uikit/types';
import cn from 'classnames';

import './NavbarPanelSection.sass';

import { buildTestid } from '../../../lib/utils';
import { useNavbarContext } from '../useNavbarContext';

export interface NavbarPanelSectionProps extends
  WithDataTestid,
  WithClassNameProp {
  children?: React.ReactNode;
  name?: string;
}

const displayName = 'NavbarPanelSection';
const testid = buildTestid(displayName);

function NavbarPanelSection({
  name = undefined,
  children = undefined,
  className = undefined,
  'data-testid': dataTestId = undefined,
}: NavbarPanelSectionProps): React.JSX.Element {
  const { type } = useNavbarContext();

  return (
    <div
      className={cn('NavbarPanel__Section', {
        [`NavbarPanel__Section_${type}`]: type,
      }, className)}
      {...testid(dataTestId)}
    >
      {!!name && (
        <span
          className={cn('NavbarPanelSection__Name')}
          {...testid('Name', dataTestId)}
        >
          {name}
        </span>
      )}

      {children}
    </div>
  );
}

NavbarPanelSection.displayName = displayName;

export { NavbarPanelSection };
